import React, { FunctionComponent } from 'react';
import styles from './process-box.module.scss';

export interface IProcessBoxProps {
  icon: {
    url: string;
    description: string;
  };
  description: string;
  title: string;
  number?: number;
}

export const ProcessBox: FunctionComponent<IProcessBoxProps> = ({
  icon,
  description,
  title,
  number
}) => (
  <div className={styles.wrapper}>
    <div className={styles.iconWrapper}>
      <span className={styles.number}>{number}</span>
      <img className={styles.icon} src={icon.url} alt={icon.description} />
    </div>
    <div className={styles.content}>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
    </div>
  </div>
);
